import LPEvent from "../classes/LPEvent";

const basket = {
    /** @type {import("../classes/LPEvent").default} */
    onChanged: new LPEvent("basket:updated"),

    /**
     * Add a product to the cart by slug.
     *
     * @param {string} product_slug - The product URL slug.
     * @param {number} [membership=1] - Whether this is a membership purchase (1) or not (0).
     * @param {((result: any) => void) | null} [callback=null] - Optional callback invoked after the product is added.
     * @returns {void}
     */
    addProduct(product_slug, membership = 1, callback = null) {
        fetch(`/add-to-cart-json/${product_slug}/${membership}`, {
            method: "POST",
            headers: {
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body: new URLSearchParams({ _token: window.CSRF_TOKEN }),
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        `Request failed with status ${response.status}`,
                    );
                }

                return response.json();
            })
            .then((result) => {
                const addedCount = Array.isArray(result?.ids)
                    ? result.ids.length
                    : 0;

                basket.completed(result);

                if (addedCount > 0) {
                    basket.updateCartAmount(addedCount);
                }

                if (typeof callback === "function") {
                    callback(result);
                }
            })
            .catch(() => {});
    },

    /**
     * Add a product to the cart by its numeric product ID.
     *
     * Used where only the product ID is available (e.g. Hello Retail search,
     * whose URL slugs can be the numeric product-ID redirect and so do not
     * resolve against product slugs).
     *
     * @param {number|string} productId - The numeric product ID.
     * @param {number} [membership=1] - Whether this is a membership purchase (1) or not (0).
     * @param {((result: any) => void) | null} [callback=null] - Optional callback invoked after the product is added.
     * @returns {void}
     */
    addProductById(productId, membership = 1, callback = null) {
        const body = new URLSearchParams();
        body.append("_token", window.CSRF_TOKEN);
        body.append("productIds[]", String(productId));
        body.append("useNormalPrice", membership ? "0" : "1");

        fetch("/add-product-ids-to-cart", {
            method: "POST",
            headers: {
                "Content-Type":
                    "application/x-www-form-urlencoded; charset=UTF-8",
            },
            body,
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error(
                        `Request failed with status ${response.status}`,
                    );
                }

                return response.json();
            })
            .then((result) => {
                const addedCount = Array.isArray(result?.ids)
                    ? result.ids.length
                    : 0;

                basket.completed(result);

                if (addedCount > 0) {
                    basket.updateCartAmount(addedCount);
                }

                if (typeof callback === "function") {
                    callback(result);
                }
            })
            .catch(() => {});
    },

    /**
     * Handle the response after a product has been added — show toast notifications.
     *
     * @param {{ toasts: string[] }} result - The server response containing toast HTML strings.
     * @returns {void}
     */
    completed(result) {
        const toasts = result.toasts;
        const container = document.querySelector(
            ".lux-toasts-container .toasts-added-to-cart",
        );

        if (!container) return;

        for (let i = 0; i < toasts.length; i++) {
            container.innerHTML += toasts[i];
        }

        const allToasts = container.querySelectorAll(".lux-toast");
        const lastToast = container.querySelector(".lux-toast:last-child");

        setTimeout(function () {
            allToasts.forEach(function (toast) {
                if (toast !== null) {
                    toast.classList.remove("active");
                }
            });

            if (lastToast) {
                lastToast.classList.add("active");
                luxPopup.toastShow(lastToast);
            }
        }, 100);

        this.onChanged.trigger(null);
    },

    /**
     * Increment the header basket counter by the given quantity.
     *
     * @param {number} qty - The number to add to the basket counter.
     * @returns {void}
     */
    updateCartAmount(qty) {
        document.querySelectorAll(".added-to-cart.error").forEach(() => {
            if (qty > 0) {
                qty = qty - 1;
            }
        });

        const basketButton = document.querySelector(
            ".lux-header-button.basket",
        );
        const basketAmount = document.querySelector(
            ".lux-header-button.basket .header-button-counter",
        );

        if (!basketButton || !basketAmount) return;

        if (
            !basketButton.classList.contains("active") ||
            basketAmount.classList.contains("sub-only")
        ) {
            basketButton.classList.add("active");
            basketAmount.textContent = String(qty);

            if (basketAmount.classList.contains("sub-only")) {
                basketAmount.classList.remove("sub-only");
            }
        } else {
            const cartAmount = parseInt(basketAmount.innerHTML);
            basketAmount.innerHTML = String(cartAmount + qty);
        }
    },

    /**
     * No-op initialiser (reserved for future use).
     *
     * @returns {void}
     */
    init() {},
};
window.basket = basket;
